import { Component } from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Accordion} from 'react-bootstrap';
import PageTitle from '../common/page-title/index';
import ArrowButton from '../common/button-arrow';
import {getPages} from '../../actions/pages';
import OnePage from './one-page';
import './styles.css';
import PageFilter from './PageFilter';

class Pages extends Component {
  UNSAFE_componentWillMount() {
    this.props.dispatch(getPages());
  }

  render() {
    const {fetched, pages} = this.props;
    if (fetched) {
      const panels = Object.keys(pages)
        .map((pageKey, indexOut) => pageKey !== 'meta' &&
          (
            <Accordion.Item
              eventKey={`page-parent-${indexOut}`}
              key={`page-parent-${indexOut}`}
            >
              <Accordion.Header>
                {pageKey}
              </Accordion.Header>
              <Accordion.Body>
                {pages[pageKey].map((page, indexIn) => (
                  <PageFilter key={indexIn} name={page.name}>
                    <OnePage key={`page-${indexIn}`} page={page}/>
                  </PageFilter>
                ))}
              </Accordion.Body>
            </Accordion.Item>
          ));

      return (
        <div className="container-fluid pages accordion">
          <PageTitle>
            Pages
          </PageTitle>
          <Link to="/admin/pages-add-edit">
            <ArrowButton
              arrow={false}
              className="add-button"
              permissions={{
                action: 'new',
                subjectClass: 'Page'
              }}
              submit={false}
            >
              New page
            </ArrowButton>
          </Link>
          <Accordion>
            {panels}
          </Accordion>
        </div>
      );
    }
    return (
      <div/>
    );
  }
}

const mapStateToProps = state => ({
  pages: state.pages.pages,
  fetched: state.pages.fetched,
  fetching: state.pages.fetching,
});

export default connect(mapStateToProps)(Pages);
